import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
export class DragAndDropService {
    constructor() {
        this.onDragStartSource = new Subject();
        this.onDragEndSource = new Subject();
        this.onDraggingSource = new Subject();
        this.onShiftIndexSource = new Subject();
        this.onParentScrollSource = new Subject();
        this.draggableChildrenSource = new Subject();
        this.isDraggableCurrentSource = new Subject();
        this.onDragStart$ = this.onDragStartSource.asObservable();
        this.onDragEnd$ = this.onDragEndSource.asObservable();
        this.onDragging$ = this.onDraggingSource.asObservable();
        this.onShiftIndex$ = this.onShiftIndexSource.asObservable();
        this.onParentScroll$ = this.onParentScrollSource.asObservable();
        this.draggableChildren$ = this.draggableChildrenSource.asObservable();
        this.isDraggableCurrent$ = this.isDraggableCurrentSource.asObservable();
        this.draggableChildren = [];
        this.nativeDraggableList = [];
        this.isDraggableCurrentSource.next(false);
    }
    emitDragStart(data) {
        this.onDragStartSource.next(data);
    }
    emitDragEnd(data) {
        this.onDragEndSource.next(data);
        this.refreshDraggableElements();
    }
    emitDragging(data) {
        this.onDraggingSource.next(data);
    }
    setParentContainer(droppableElement) {
        this.droppableElement = droppableElement;
    }
    emitParentScroll(data) {
        this.onParentScrollSource.next(data);
    }
    getParentContainer() {
        return this.droppableElement;
    }
    registerDraggable(draggable) {
        this.isDraggableCurrentSource.next(false);
        this.draggableChildren.push(draggable);
        this.refreshDraggableElements();
    }
    deregisterDraggable(draggable) {
        this.isDraggableCurrentSource.next(false);
        const childIndex = this.draggableChildren.indexOf(draggable);
        this.draggableChildren.splice(childIndex, 1);
        this.finalizeDeregistration();
    }
    // waits to finalize reindexing draggables in event of multiple
    // draggables being destroyed and deregistered at once.
    finalizeDeregistration() {
        window.clearTimeout(this.deregisterTimeoutId);
        this.deregisterTimeoutId = window.setTimeout(this.simpleRefreshDraggables.bind(this), 100);
    }
    refreshDraggableElements() {
        window.clearTimeout(this.refreshTimeoutId);
        this.refreshTimeoutId = window.setTimeout(this.reindexDraggables.bind(this), 100 // 0.1s
        );
    }
    reindexDraggables() {
        this.nativeDraggableList = Array.from(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.droppableElement.elementRef.nativeElement.querySelectorAll('.mheDraggable'));
        if (this.nativeDraggableList.length !== this.draggableChildren.length) {
            return;
        }
        const refreshedDraggables = [];
        this.nativeDraggableList.forEach((el, elIndex) => {
            let tempIndex = 0;
            const draggableChild = this.draggableChildren.find((child, childIndex) => {
                tempIndex = childIndex;
                return child.elementRef.nativeElement === el;
            });
            this.draggableChildren.splice(tempIndex, 1);
            if (draggableChild) {
                draggableChild.setElementIndex(elIndex);
                refreshedDraggables.push(draggableChild);
            }
        });
        this.draggableChildren = refreshedDraggables;
        this.draggableChildrenSource.next(this.draggableChildren);
        this.isDraggableCurrentSource.next(true);
    }
    // ignores the DOM, which can be out of date if indexing happens onDestroy.
    simpleRefreshDraggables() {
        this.draggableChildren.forEach((el, i) => {
            el.setElementIndex(i);
        });
        this.draggableChildrenSource.next(this.draggableChildren);
        this.isDraggableCurrentSource.next(true);
    }
}
DragAndDropService.ɵfac = function DragAndDropService_Factory(t) { return new (t || DragAndDropService)(); };
DragAndDropService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DragAndDropService, factory: DragAndDropService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DragAndDropService, [{
        type: Injectable
    }], function () { return []; }, null); })();
